import { apiRequest } from "./apiRequest";

export const fetchErrorLog = async <T>(requestParam: number): Promise<T> => {
  return apiRequest<T>("get", `/errors/${requestParam}`);
};
